function getTokens() {
  if (typeof window === "undefined") return { accessToken: null, refreshToken: null }
  return {
    accessToken: localStorage.getItem("access_token"),
    refreshToken: localStorage.getItem("refresh_token"),
  }
}

async function refreshAccessToken(): Promise<string | null> {
  const { refreshToken } = getTokens()
  if (!refreshToken) return null

  const res = await fetch("/api/v1/auth/refresh", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refresh_token: refreshToken }),
  })
  if (!res.ok) {
    clearTokens()
    return null
  }

  const data = await res.json()
  storeTokens(data.access_token, data.refresh_token)
  return data.access_token
}

async function fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
  const { accessToken } = getTokens()

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(options.headers as Record<string, string> | undefined),
  }

  if (accessToken) {
    headers["Authorization"] = `Bearer ${accessToken}`
  }

  let res = await fetch(url, { ...options, headers })

  if (res.status === 401 && accessToken) {
    const newToken = await refreshAccessToken()
    if (newToken) {
      headers["Authorization"] = `Bearer ${newToken}`
      res = await fetch(url, { ...options, headers })
    }
  }

  return res
}

function storeTokens(access: string, refresh: string) {
  if (typeof window !== "undefined") {
    localStorage.setItem("access_token", access)
    localStorage.setItem("refresh_token", refresh)
  }
}

function clearTokens() {
  if (typeof window !== "undefined") {
    localStorage.removeItem("access_token")
    localStorage.removeItem("refresh_token")
  }
}

export const api = {
  get: (url: string, options?: RequestInit) =>
    fetchWithAuth(url, { ...options, method: "GET" }),
  post: (url: string, body?: unknown, options?: RequestInit) =>
    fetchWithAuth(url, {
      ...options,
      method: "POST",
      body: body ? JSON.stringify(body) : undefined,
    }),
  put: (url: string, body?: unknown, options?: RequestInit) =>
    fetchWithAuth(url, {
      ...options,
      method: "PUT",
      body: body ? JSON.stringify(body) : undefined,
    }),
  delete: (url: string, options?: RequestInit) =>
    fetchWithAuth(url, { ...options, method: "DELETE" }),
  getTokens,
  setTokens: storeTokens,
  clearTokens,
}
